import {stringIsSet} from "../providers/service/global-variables.service";
import {ProgettiParse} from "./Progetti.Parse";

export class Switch {
    localId: string
    _objectId: string | undefined
    _floor?: number;
    _lastComm: Date | undefined;
    _name: string | undefined;
    _online: boolean | undefined;
    _progetto: ProgettiParse | undefined;
    _room: string | undefined;
    _status: SwitchStatus | undefined;

    constructor(objectId: string | undefined) {
        if (stringIsSet(objectId)) {
            this.objectId = objectId;
        }
        this.localId = new Date().getTime().toString();
    }

    set objectId(value) {
        this._objectId = value
    }

    get objectId(): string {
        if (stringIsSet(this._objectId)) {
            return this._objectId;
        } else {
            return this.localId;
        }
    }

    set floor(value) {
        this._floor = value
    }

    get floor(): number | undefined {
        return this._floor;
    }

    get lastComm(): Date | undefined {
        return this._lastComm;
    }

    set lastComm(value) {
        this._lastComm = value
    }

    set name(value) {
        this._name = value
    }

    get name(): string | undefined {
        if (stringIsSet(this._name)) {
            return this._name;
        } else {
            return undefined;
        }
    }

    get online(): boolean | undefined {
        return this._online;
    }

    set online(value) {
        this._online = value
    }

    get progetto(): ProgettiParse | undefined {
        return this._progetto;
    }

    set progetto(value) {
        this._progetto = value
    }

    get room(): string | undefined {
        return this._room;
    }

    set room(value) {
        this._room = value
    }


    get status(): SwitchStatus | undefined {
        return this._status;
    }

    set status(value) {
        this._status = value
    }

    fromJson(json: any) {
        Object.keys(json)
            .filter(key => ['name', 'objectId', 'status', 'lastComm', 'online', 'room', 'status', 'progetto'].includes(key))
            .forEach(key => {
                if (json[key] != null && key in this) {
                    (this as any)[key] = json[key]
                }
            })
        return this;
    }
}


export enum SwitchStatus {
    OFF,
    ON,
}
